// CSS Modules - component class name: MenuTeaserColumn__

<template>
  <section
    :class="[{ MenuTeaserColumn__doubleWide: doubleWide }, $style.container]"
  >
    <div>
      <span
        :class="{ MenuTeaserColumn__hiddenTitle: !title }"
        v-html="title"
      ></span>
      <MenuTeaser
        v-for="elm in columnData"
        :key="elm.title + elm.id"
        :title="elm.title"
        :image="elm.image"
        :url="elm.url"
      />
    </div>
  </section>
</template>

<script>
import MenuTeaser from "../MenuTeaser/MenuTeaser.vue";

export default {
  name: "MenuTeaserColumn",
  components: {
    MenuTeaser
  },
  props: {
    title: String,
    doubleWide: {
      type: Boolean,
      default: false
    },
    columnData: {
      type: Array,
      default: []
    }
  }
};
</script>

<style module lang="scss">
@import "./MenuTeaserColumn.scss";
</style>
